module.exports = __webpack_public_path__ + "media/images/icons/filled/reconciliation-dc063ed2258afde84a7e82f98047d12c.svg";